import { Account } from '@/entities/Account';
import { AccountRelation } from '@/entities/AccountRelation';

export type RelationType = 'merchant' | 'partner';

export const getCurrentRelationType = (
  account?: Account,
  relations?: AccountRelation[],
): RelationType | undefined => {
  if (relations) {
    const defaultRelation =
      relations.find((item) => item.isDefault) || relations[0];

    if (defaultRelation) {
      if (`${defaultRelation.type}` === '1') {
        return 'partner';
      }

      if (`${defaultRelation.type}` === '2') {
        return 'merchant';
      }
    }
  }

  if (account) {
    if (['partner', 'merchant'].includes(account.relation)) {
      return account.relation as RelationType;
    }
  }

  return undefined;
};
